import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { Injector, Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { AauditProcessHead } from '../entities/aaudit-process-head';
import { Observable, Subject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import * as FileSaver from 'file-saver';


@Injectable()
export class AauditProcessHeadService extends BaseCrudService<AauditProcessHead> {

    public uri = '/api/aauditProcessHead/';
    public updateLidt:Subject<any> = new Subject<any>();
    constructor(injector: Injector) {
        super(injector);
    //    console.log('Instance AauditProcessService');
    }

    buildSentence(entity?: AauditProcessHead, event?: LazyLoadEvent): HttpParams {
    if (entity) {
        let query = '';
        if (entity.process && entity.process.id) {
            query = query.concat(
                `process.id${QueryOperator.Equal}${entity.process.id}${QueryOperator.Split}`
            );
        }

        this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
        const page = ((event.first + event.rows) / event.rows - 1).toString();
        const size = event.rows.toString();
        this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
        this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        
        this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);

    }
    let sortOrder = 'desc';
    this.httpParams =  this.httpParams.set(QueryOperator.SortParam, `id,${sortOrder}`);


    return this.httpParams;
    }


    uploadFile(aauditHeadId: number,file: File): Observable<any> {
        const url = `${this.rutaServidor}${this.uri}updateFile`;
        let params = new HttpParams()
        .set('aauditHeadId', aauditHeadId.toString())

        this.spinnerService.showAll();
      const uploadData: FormData = new FormData();
      uploadData.append('file', file, file.name);
      return this.httpClient.post(url, uploadData ,{params})
      .pipe(
        tap(response => {
            //console.log(response);
             this.spinnerService.hideAll();
         }),
          catchError((err) => { 
                        //console.log("catchError : "  + catchError);
                       this.spinnerService.hideAll();
                       
                        // this.notificationService.smallBoxError(err.error.messages[0]); 
        
                       this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                       return new Observable<any>();
                    })
     );
    }

    downloadFile(euId:number ,key: string , url : string,nameFile:string): Observable<Blob> {
            let ruta = this.rutaServidor + this.uri   +  url; 
              let params = new HttpParams()
        .set('euId', euId.toString())
        .set('key', key)
        
             const options = {
                params: params,
                responseType: 'blob' as 'json'
            };    

            this.spinnerService.showAll();
            return this.httpClient.get(ruta, options)
                .pipe( 
                    map(res =>  { 
                        this.spinnerService.hideAll();
                        let bean = new Blob([res],{ type: 'application/zip'});
                        FileSaver.saveAs(bean, nameFile);
                        return bean;
                     }   ),
                    catchError((err) => { 
                        //console.log("catchError : "  + catchError);
                       this.spinnerService.hideAll();
                       this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                       return new Observable<Blob>();
                    })
                     
                    ) ;
     
        }

    
         downloadFromPresignedUrl(euId:number ,key: string , url : string,nameFile:string): Observable<any> {
            let ruta = this.rutaServidor + this.uri   +  url; 
              let params = new HttpParams()
            .set('euId', euId.toString())
            .set('key', key)
        
             const options = {
                params: params,                                                                                                             
                responseType: 'text' as 'json'
            };    

            this.spinnerService.showAll();
            return this.httpClient.get(ruta, options);
                
     
        }
        
}




// WEBPACK FOOTER //
// ./src/app/core/services/aaudit-process-head.service.ts